import { Box, Loader } from '@mantine/core';
import { FC, memo, useMemo } from 'react';

type Props = {
  height?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
};

export const ComponentLoader: FC<Props> = memo(
  ({ height = '100%', size = 'md' }) => {
    const style = useMemo(
      () => ({ alignItems: 'center', height, justifyContent: 'center' }),
      [height]
    );

    return (
      <Box display="flex" style={style}>
        <Loader size={size} />
      </Box>
    );
  }
);
